import React from "react";
import PropTypes from "prop-types";
import i18n from "i18n-react";
import * as FaIcons from "react-icons/fa";
import DashboardProgressPanel from "../../../components/dashboard/DashboardProgressPanel";
import { formatNumber, formatPercent, getComparisonText } from "./ordersDashboardFormatters";

const ConversionPanel = ({ dashboard }) => {
    const ratio = Number(dashboard?.visitOrderRatio || 0);
    const stats = [
        {
            label: i18n.translate("orders_dashboard_executed_visits"),
            value: formatNumber(dashboard?.executedVisits)
        },
        {
            label: i18n.translate("orders_dashboard_productive_visits"),
            value: formatNumber(dashboard?.productiveVisits)
        },
        {
            label: i18n.translate("orders_dashboard_visits_without_order"),
            value: formatNumber(dashboard?.visitsWithoutOrder),
            danger: true
        },
        {
            label: i18n.translate("orders_dashboard_vs_previous_period"),
            comparison: dashboard?.visitOrderRatioComparison
        }
    ];

    return (
        <DashboardProgressPanel
            title={i18n.translate("orders_dashboard_visit_sale_conversion")}
            icon={<FaIcons.FaRoute className="orders-title-icon green" />}
            percent={ratio}
            percentLabel={formatPercent(ratio)}
            centerLabel={i18n.translate("orders_dashboard_effectiveness")}
            stats={stats}
            comparisonFormatter={getComparisonText}
        />
    );
};

ConversionPanel.propTypes = {
    dashboard: PropTypes.shape({
        visitOrderRatio: PropTypes.number,
        executedVisits: PropTypes.number,
        productiveVisits: PropTypes.number,
        visitsWithoutOrder: PropTypes.number,
        visitOrderRatioComparison: PropTypes.object
    }).isRequired
};

export default ConversionPanel;
